/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { BuildingOfficeIcon16Light } from './BuildingOfficeIcon16Light';
import { BuildingOfficeIcon16Regular } from './BuildingOfficeIcon16Regular';
import { BuildingOfficeIcon16Solid } from './BuildingOfficeIcon16Solid';
import { BuildingOfficeIcon20Light } from './BuildingOfficeIcon20Light';
import { BuildingOfficeIcon20Regular } from './BuildingOfficeIcon20Regular';
import { BuildingOfficeIcon20Solid } from './BuildingOfficeIcon20Solid';
import { BuildingOfficeIcon24Regular } from './BuildingOfficeIcon24Regular';
import { BuildingOfficeIcon24Solid } from './BuildingOfficeIcon24Solid';
import { BuildingOfficeIcon32Regular } from './BuildingOfficeIcon32Regular';
import { BuildingOfficeIcon64Regular } from './BuildingOfficeIcon64Regular';
var sizes = {
    16: {
        light: BuildingOfficeIcon16Light,
        regular: BuildingOfficeIcon16Regular,
        solid: BuildingOfficeIcon16Solid,
    },
    20: {
        light: BuildingOfficeIcon20Light,
        regular: BuildingOfficeIcon20Regular,
        solid: BuildingOfficeIcon20Solid,
    },
    24: {
        regular: BuildingOfficeIcon24Regular,
        solid: BuildingOfficeIcon24Solid,
    },
    32: {
        regular: BuildingOfficeIcon32Regular,
    },
    64: {
        regular: BuildingOfficeIcon64Regular,
    },
};
export var BuildingOfficeIcon = forwardRef('BuildingOfficeIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
